export const extractS3Key = (xmlText: string, fallback: string): string => {
  const match = xmlText.match(/<Key>([^<]+)<\/Key>/)
  return match ? match[1] : fallback
}
